<template>
  <div>
    <v-app-bar
      dense
      width="100%"
      permanent
      class="cust-appbar px-0 px-md-2 overflow-hidden"
    >
      <img src="@/assets/logo.svg" style="max-width: 80px" alt="zebulogo" />
      <v-spacer></v-spacer>
      <!-- <v-row class="flex-row-reverse mr-0 mr-md-4 pt-4">
        <v-list nav color="transparent">
          <v-list-item-group class="d-flex">
            <v-list-item
              style="background-color: #ebeffa" :href="`https://profile.mynt.in/`"
              class="px-4 mx-1 mb-0 rounded-t-lg"
              to="/profile"
            >
              <v-list-item-title
                style="color: #0037b7"
                class="font-weight-medium text-capitalize"
              >
                Profile
              </v-list-item-title>
            </v-list-item>
            <v-list-item
              class="px-4 mx-1 mb-0"
              :href="`https://fund.mynt.in/`"
            >
              <v-list-item-title
                style="color: #666"
                class="font-weight-medium text-capitalize"
              >
                Funds
              </v-list-item-title>
            </v-list-item>

            <v-list-item
              class="px-4 mx-1 mb-0"
              :href="`https://reports-cf9df.web.app/`"
            >
              <v-list-item-title
                style="color: #666"
                class="font-weight-medium text-capitalize"
              >
                Reports
              </v-list-item-title>
            </v-list-item>

   
          </v-list-item-group>
        </v-list>
      </v-row> -->



    </v-app-bar>
    <v-container class="body-card overflow-hidden" v-if="cod&&member&&uString&&accept">
      <div class="pt-12">
        <p class="font-weight-bold fs-22 mb-0">Request pending</p>
              <p class="subtitle-2 txt-666">
               You have requested to link your {{ member }} account to {{ cod }} as family account.
              </p>
        <v-card
                class="pa-6 mb-6"
                style="border: 1px solid #dddddd !important"
                outlined
                width="100%"
              >
              <div align="center" >
                                        <v-img
                                          class="mt-1"
                                          max-height="100"
                                          max-width="100"
                                          src="@/assets/family-icon.png"
                                        />
                                      </div>
              <p align="center" class="subtitle-1 txt-666 font-weight-medium pt-6">
                    <b>{{cod}}</b> wants to add your account to their family portfolio
                  <br>  <b >Once you accept, they can view your holdings</b>  </p> 
                  <v-card-actions class="pb-2" >
          <v-row  justify="center" no-gutters>
            <v-col md="3">
              <v-btn
                height="40px"
                block
                color="grey darken-1 text-none"
                text
                @click="declineBtn"
              >
                Decline
              </v-btn>
            </v-col>
            <v-col md="3">
              <v-btn
                height="40px"
                block
                color="green darken-1 text-none"
                text
                @click="acceptBtn"
              >
                Accept
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
                </v-card>
      </div>
    </v-container>
    <v-container class="body-card overflow-hidden" v-else>
        <p class="font-weight-bold fs-22 mt-14 pt-3 mb-0">THANK YOU! <b>{{cod}}</b> </p>

        <v-card
                class="pa-6 mt-2 mb-6"
                style="border: 1px solid #dddddd !important"
                outlined
                width="100%"
              >
              <div align="center" >
                                      <v-icon size="55" color="green">mdi-check-circle-outline</v-icon>
                                      </div>
              <p align="center" class="subtitle-1 txt-666 font-weight-medium pt-6">
                    Your ressponce has been recorded sucessfully, 
                  <br>  You can check this out  <a href="https://profile.mynt.in/family">Click Here</a>  </p> 
         
                </v-card>
  
    </v-container>
    <v-snackbar
          style="z-index: 9999"
          class="pt-6 pr-md-6 snakbar-sty rounded-pill"
          elevation="0"
          text-color="white"
          transition="slide-x-reverse-transition"
          v-model="errorSnackbar"
          :timeout="4000"
          :value="true"
          color="error"
        >
          <v-icon class="mr-2" color="white">mdi-alert-outline</v-icon>
          {{ errtext }}
          <v-icon
            @click="errorSnackbar = false"
            class="float-right"
            color="white"
            >mdi-close-circle</v-icon
          >
        </v-snackbar>
  </div>
</template>

<script>
import api from "@/Api.js";
import axios from "axios";

export default {
    data() {
    return {
        cod:'',
        member:'',
        uString:'',
        accept:true,
        errorSnackbar:false,
        errtext:''
    }
    },
    methods: {
        acceptBtn() {
      var axiosThis = this
            let data = JSON.stringify({
                "clientid": this.cod,
                "memberid": this.member,
                "unique_string": this.uString
                });

                let config = {
                method: 'post',
                url: api.api_url +'/family_accept',
                headers: { 
                    'Content-Type': 'application/json'
                },
                data : data
                };

                axios.request(config)
                .then((response) => {
                    if(response.data.emsg == "linked successfully") {
                        axiosThis.accept = false
                    } else {
                        axiosThis.errorSnackbar = true;
              axiosThis.errtext = response.data.emsg;

                    }
                // console.log(JSON.stringify(response.data));
                })
                .catch((error) => {
                console.log(error);
                });
        },
        declineBtn() {
      var axiosThis = this
        let data = JSON.stringify({
              "id": this.id,
              "clientid": this.cod,
                "memberid": this.member,
                "unique_string": this.uString
          });

        let config = {
          method: "post",
          url: api.api_url + "/decline_family_member",
          headers: {
            "Content-Type": "application/json",
          },
          data: data,
        };

        axios
          .request(config)
          .then((response) => {
            if(response.data.emsg == "id declined successfully") {
            axiosThis.familyrequest = false
            axiosThis.successSnackbar = true;
            axiosThis.Succtext = "Removed sucessfully";
            axiosThis.accept = false
            }  else {
                        axiosThis.errorSnackbar = true;
              axiosThis.errtext = response.data.emsg;

                    }
            // console.log(JSON.stringify(response.data));
            axiosThis.familystatusloading = false
            axiosThis.getFamily()
          })
          .catch((error) => {
            console.log(error);
          });

    },
    },
mounted() {
    let params = new URL(document.location).searchParams;
    // var axiosThis = this;
    this.cod = params.get("clientid");
    this.id = params.get("id");
    this.member = params.get("memberid");
    this.uString = params.get("unique_string");
    // console.log(this.cod,this.member,this.uString);
},
}
</script>

<style>
.cust-appbar {
  background-color: white !important;
  position: fixed !important;
  z-index: 1 !important;
  border-bottom: 1px solid #eceff3 !important;
  box-shadow: 0px 1px 15px 0px rgba(44, 44, 45, 0.03),
    0px 5px 22px 0px rgba(154, 154, 156, 0.02) !important;
}

*,
html,
body .v-application,
.v-application .display-4,
.v-application .display-3,
.v-application .display-1,
.v-application .headline,
.v-application .title,
.v-application .subtitle-1,
.v-application .subtitle-2,
.v-application .body-1,
.v-application .body-2,
.v-application .caption,
.v-application .overline {
  font-family: "Tenon" !important;
}
</style>